import IMask from 'imask';

export function formatarPorcentagem(
  texto,
  valorDefault = '0 %',
  decimais = 2,
  sufixo = '%'
) {
  if (texto) {
    return `${parseFloat(texto)
      .toFixed(decimais)
      .replace('.', ',')} ${sufixo}`;
  }
  return valorDefault;
}

export function formatarTonelada(texto, valorDefault = '0', sufixo = 't') {
  if (texto) {
    return `${texto
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.')} ${sufixo}`;
  }
  return `${valorDefault} ${sufixo}`;
}

export function formatarMoeda(
  texto,
  valorDefault = '-',
  decimais = 2,
  prefixo = 'R$'
) {
  if (texto) {
    return `${prefixo} ${parseFloat(texto)
      .toFixed(decimais)
      .replace('.', ',')}`;
  }
  return valorDefault;
}

export function formatarMilhar(
  texto,
  valorDefault = '0,00',
  padFractionalZeros = true
) {
  if (texto) {
    return IMask.createMask({
      mask: 'num',
      blocks: {
        num: {
          mask: Number,
          thousandsSeparator: '.',
          radix: ',',
          scale: 2,
          padFractionalZeros,
          signed: true,
        },
      },
    }).resolve(String(texto));
  }

  return valorDefault;
}

export function formatarMoedaIMask(texto, valorDefault = 'R$0,00') {
  if (texto) {
    const maskedValue = IMask.createMask({
      mask: 'R$num',
      blocks: {
        num: {
          mask: Number,
          thousandsSeparator: '.',
          radix: ',',
          scale: 2,
          padFractionalZeros: true,
          signed: true,
        },
      },
    }).resolve(String(texto));
    return maskedValue;
  }

  return valorDefault;
}

export function formatarTelefoneIMask(
  texto,
  valorDefault = '(00) 0 0000-0000'
) {
  if (texto) {
    const maskedValue = IMask.createMask({
      mask: '(00) 0 0000-0000',
      blocks: {
        num: {
          mask: Number,
          thousandsSeparator: '.',
          radix: ',',
          scale: 2,
          padFractionalZeros: true,
          signed: true,
        },
      },
    }).resolve(String(texto));
    return maskedValue;
  }

  return valorDefault;
}

export function formatarCnpjCpfIMask(
  texto,
  valorDefault = '00.000.000/0000-00'
) {
  if (texto) {
    const masks = {
      cpf: '000.000.000-00',
      cnpj: '00.000.000/0000-00',
    };
    const maskedValue = IMask.createMask({
      mask: texto.length === 11 ? masks.cpf : masks.cnpj,
    }).resolve(String(texto));
    return maskedValue;
  }

  return valorDefault;
}

export function removeMoedaMask(value) {
  if (typeof value === 'number') return value;
  return parseFloat(
    value
      .replace('R$', '')
      .trim()
      .replace(/[.]/g, '')
      .replace(',', '.')
  );
}

export function removeThousandSeparatorMask(value) {
  if (typeof value === 'number') return value;
  return parseFloat(
    value
      .toString()
      .replace(/[.]/g, '')
      .replace(',', '.')
  );
}

export function removePorcentagemMask(value) {
  if (typeof value === 'number') return value;
  return parseFloat(
    value
      .trim()
      .replace('% ', '')
      .replace(/[.]/g, '')
      .replace(',', '.')
  );
}

export function removePorcentagemMoedaMask(value) {
  if (typeof value === 'number') return value;
  return parseFloat(
    value
      .trim()
      .replace('% ', '')
      .replace('R$', '')
      .replace(/[.]/g, '')
      .replace(',', '.')
  );
}

export function formatarPorcentagemSufixoEsquerda(
  texto,
  valorDefault = '% 0',
  decimais = 2,
  sufixo = '%'
) {
  if (texto) {
    return `${sufixo} ${parseFloat(texto)
      .toFixed(decimais)
      .replace('.', ',')}`;
  }
  return valorDefault;
}

export function removeCaracteresEspeciais(texto) {
  if (texto) {
    return texto.replace(/[&/\\#,+()$~%.'":*?<>{}-]/g, '');
  }
  return texto;
}

export function removeCpfMask(texto) {
  if (texto) {
    return texto.replace(/[&/\\#,+()$~%.'":*?<>{}-]/g, '');
  }
  return texto;
}

/**
 * @description Transforma uma string em maiúsculo,
 * em alguns casos passe String(value) como parâmetro.
 * @param {String} value
 * @returns value.toUpperCase()
 */
export const customUpperCase = value => value.toUpperCase();

/**
 *
 * @param {String} string - String a ser formatada
 * @returns string - String formatada
 */
export function toTitleCase(string) {
  if (string) {
    return string.replace(
      /\w\S*/g,
      txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    );
  }
  return string;
}

export function toFixedNumber(num, fixed) {
  if (num) {
    const result = new RegExp(`^-?\\d+(?:.\\d{0,${fixed || -1}})?`);
    return num.toString().match(result)[0];
  }
  return num;
}

export function formatarPlaca(placa) {
  if (!placa) {
    return;
  }
  const pattern = /^(\w{3})(\w{4})/;
  const replacer = '$1-$2';
  return placa.replace(pattern, replacer).toUpperCase();
}

export function limitarLabel(value, size) {
  if (value && value.length > size) {
    return `${value.slice(0, size)}...`;
  }
  return value;
}

export function abreviarNumero(value) {
  if (String(value).length < 4) {
    return value;
  }

  if (String(value).length < 7) {
    const newValue = value / 1000;
    return `${newValue.toFixed(2).replace('.', ',')} mil`;
  }

  if (String(value).length >= 7) {
    const newValue = value / 1000000;
    return `${newValue.toFixed(2).replace('.', ',')} mi`;
  }
}

export function abreviarNumeroSemDecimal(value) {
  if (String(value).length < 4) {
    return value;
  }

  if (String(value).length < 7) {
    const newValue = value / 1000;
    return `${newValue} mil`;
  }

  if (String(value).length >= 7) {
    const newValue = value / 1000000;
    return `${newValue} mi`;
  }
}

export function formatarPorcentagemValorAbsoluto(
  texto,
  valorDefault = '0 %',
  decimais = 2,
  sufixo = '%'
) {
  if (texto) {
    const newValue = texto * 100;

    const result = `${parseFloat(newValue)
      .toFixed(decimais)
      .replace('.', ',')} ${sufixo}`;

    return result;
  }
  return valorDefault;
}

export function formatarValorPorcentagemSimples(value) {
  if (value) {
    const newValue = Math.trunc(value);
    const formatt = newValue / 100;
    return formatt.toFixed(2);
  }

  return value;
}

export function formatarPorcentagemAderencia(value) {
  if (value) {
    const formatt = value * 100;
    return formatt.toFixed(2);
  }

  return value;
}
